import { createContext, useContext, ReactNode } from 'react';

type RepositoryFormContextType = {
  isLoading: boolean;
};

const RepositoryFormContext = createContext<
  RepositoryFormContextType | undefined
>(undefined);

export const useRepositoryFormContext = () => {
  const context = useContext(RepositoryFormContext);
  if (context === undefined) {
    throw new Error(
      'useRepositoryFormContext must be used within a RepositoryFormProvider',
    );
  }
  return context;
};

type RepositoryFormProviderProps = {
  isLoading: boolean;
  children: ReactNode;
};

export const RepositoryFormProvider = ({
  isLoading,
  children,
}: RepositoryFormProviderProps) => (
  <RepositoryFormContext.Provider value={{ isLoading }}>
    {children}
  </RepositoryFormContext.Provider>
);
